import styled from 'styled-components'

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: #fff;
  border: 1px solid #e11d48;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`

export const AlertText = styled.p`
  color: #e11d48;
  font-weight: 600;
  font-size: 1rem;
  margin: 0;
`

export const ActionButton = styled.button`
  background-color: #e11d48;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #be123c;
  }

  &:focus {
    outline: 2px solid #e11d48;
    outline-offset: 2px;
  }
`
